/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const UPDATE_STATS = 'UPDATE_STATS';
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_CUSTOMER = 'REGISTER_CUSTOMER';
export const REGISTER_CUSTOMER_SUCCESS = 'REGISTER_CUSTOMER_SUCCESS';
export const REGISTER_CUSTOMER_ERROR = 'REGISTER_CUSTOMER_ERROR';
export const REGISTER_BROKER = 'REGISTER_BROKER';
export const REGISTER_BROKER_SUCCESS = 'REGISTER_BROKER_SUCCESS';
export const REGISTER_BROKER_ERROR = 'REGISTER_BROKER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const REVERIFY = 'REVERIFY';
export const REGISTERING_USER = 'REGISTERING_USER';
export const CREATING_GUEST_USER = 'CREATING_GUEST_USER';
export const GUEST_USER_CREATED = 'GUEST_USER_CREATED';
export const USER_REGISTERED = 'USER_REGISTERED';
export const USER_REGISTRATION_ERROR = 'USER_REGISTRATION_ERROR';
export const SET_USER_REGISTERED_CLEAN = 'SET_USER_REGISTERED_CLEAN';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* INSURANCE TYPES  */
export const GET_INSURANCE_TYPES = 'GET_INSURANCE_TYPES';
export const GET_INSURANCE_TYPES_ERROR = 'GET_INSURANCE_TYPE_ERROR';
export const ADD_INSURANCE_TYPE_ERROR = 'ADD_INSURANCE_TYPE_ERROR';
export const UPDATE_INSURANCE_TYPE_ERROR = 'UPDATE_INSURANCE_TYPE_ERROR';
export const DELETE_INSURANCE_TYPE_ERROR = 'DELETE_INSURANCE_TYPE_ERROR';
export const ACTIVATE_INSURANCE_TYPE_ERROR = 'ACTIVATE_INSURANCE_TYPE_ERROR';

export const GET_INSURANCE_TYPES_SUCCESS = 'GET_INSURANCE_TYPE_SUCCESS';
export const GET_INSURANCE_TYPES_ADMIN_SUCCESS =
  'GET_INSURANCE_TYPES_ADMIN_SUCCESS';
export const ADD_INSURANCE_TYPE_SUCCESS = 'ADD_INSURANCE_TYPE_SUCCESS';
export const UPDATE_INSURANCE_TYPE_SUCCESS = 'UPDATE_INSURANCE_TYPE_SUCCESS';
export const DELETE_INSURANCE_TYPE_SUCCESS = 'DELETE_INSURANCE_TYPE_SUCCESS';
export const ACTIVATE_INSURANCE_TYPE_SUCCESS =
  'ACTIVATE_INSURANCE_TYPE_SUCCESS';
export const FORMS_BY_INSURANCE_TYPE = 'FORMS_BY_INSURANCE_TYPE';
export const FORMS_BY_INSURANCE_TYPE_LOADER = 'FORMS_BY_INSURANCE_TYPE_LOADER';

export const SINGLE_FORM_BY_INSURANCE_TYPE_LOADER =
  'SINGLE_FORM_BY_INSURANCE_TYPE_LOADER';
export const SINGLE_FORM_BY_INSURANCE_TYPE = 'SINGLE_FORM_BY_INSURANCE_TYPE';
export const SINGLE_FORM_BY_INSURANCE_ERROR =
  'SINGLE_FORM_BY_INSURANCE_TYPE_ERROR';
export const ALL_FORMS_OF_INSURANCE = 'ALL_FORMS_OF_INSURANCE';
export const ALL_FORMS = 'ALL_FORMS';

// *********************AUCTIONS  TYPES**********************//

export const GET_USER_AUCTIONS = 'GET_USER_AUCTIONS';
